import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from 'src/app/shared/shared.module';
import { QuizSystemModule } from '../quiz-system/quiz-system.module';

import { ModuleRwComponent } from './module-rw/module-rw.component';
import { ModulePageRwComponent } from './module-page-rw/module-page-rw.component';
import { PageActivitySimpleQuizProblemReportingRwComponent } from './page-activity-simple-quiz-problem-reporting-rw/page-activity-simple-quiz-problem-reporting-rw.component';
import { PageActivitySimpleQuizWhosResponsibleRwComponent } from './page-activity-simple-quiz-whos-responsible-rw/page-activity-simple-quiz-whos-responsible-rw.component';
import { PageActivityFlippingCardsForPositiveCommunicationRwComponent } from './page-activity-flipping-cards-for-positive-communication-rw/page-activity-flipping-cards-for-positive-communication-rw.component';
import { PageActivitiesRwComponent } from './page-activities-rw/page-activities-rw.component';
import { PageActivityBudgetingQuizRwComponent } from './page-activity-budgeting-quiz-rw/page-activity-budgeting-quiz-rw.component';
import { PageActivityCompareThreeHousingUnitsRwComponent } from './page-activity-compare-three-housing-units-rw/page-activity-compare-three-housing-units-rw.component';
import { PageSampleCreditReportOrderRwComponent } from './page-sample-credit-report-order-rw/page-sample-credit-report-order-rw.component';
import { PageSampleLetterAboutIncorrectCreditReportRwComponent } from './page-sample-letter-about-incorrect-credit-report-rw/page-sample-letter-about-incorrect-credit-report-rw.component';
import { PageActivityReviewLeaseAgreementAndAnswerRwComponent } from './page-activity-review-lease-agreement-and-answer-rw/page-activity-review-lease-agreement-and-answer-rw.component';
import { PageActivitySimpleQuizMovingOnRwComponent } from './page-activity-simple-quiz-moving-on-rw/page-activity-simple-quiz-moving-on-rw.component';
import { PageActivityEstimatingMonthlyIncomeNancyRwComponent } from './page-activity-estimating-monthly-income-nancy-rw/page-activity-estimating-monthly-income-nancy-rw.component';
import { PageActivityEstimatingMonthlyExpensesNancyRwComponent } from './page-activity-estimating-monthly-expenses-nancy-rw/page-activity-estimating-monthly-expenses-nancy-rw.component';
import { PageActivityNeedsVsWantsRwComponent } from './page-activity-needs-vs-wants-rw/page-activity-needs-vs-wants-rw.component';
import { PageActivityCardItemComponent } from './page-activity-needs-vs-wants-rw/page-activity-card-item/page-activity-card-item.component';

@NgModule({
  declarations: [
    ModuleRwComponent,
    ModulePageRwComponent,
    PageActivitySimpleQuizProblemReportingRwComponent,
    PageActivitySimpleQuizWhosResponsibleRwComponent,
    PageActivityFlippingCardsForPositiveCommunicationRwComponent,
    PageActivitiesRwComponent,
    PageActivityBudgetingQuizRwComponent,
    PageActivityCompareThreeHousingUnitsRwComponent,
    PageSampleCreditReportOrderRwComponent,
    PageSampleLetterAboutIncorrectCreditReportRwComponent,
    PageActivityReviewLeaseAgreementAndAnswerRwComponent,
    PageActivitySimpleQuizMovingOnRwComponent,
    PageActivityEstimatingMonthlyIncomeNancyRwComponent,
    PageActivityEstimatingMonthlyExpensesNancyRwComponent,
    PageActivityNeedsVsWantsRwComponent,
    PageActivityCardItemComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    QuizSystemModule
  ],
})
export class RentwiseModule { }
